(() => {
  if (customElements.get('emmetre-product')) return;
  const dayKey = date => date.toISOString().slice(0, 10);
  function easter(year) {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    return new Date(Date.UTC(year,Math.floor((h+l-7*m+114)/31)-1,(h+l-7*m+114)%31+1));
  }
  function shipping(config, now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const part = name => parts.find(p => p.type === name).value;
    const date = new Date(`${part('year')}-${part('month')}-${part('day')}T00:00:00Z`);
    const extra = new Set((config.extraClosed || '').split(/[\s,;]+/));
    let remaining = Math.max(1, Math.min(60, Math.round(Number(config.leadDays) || 10)));
    const annual = value => /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(value || '');
    const start = config.closedStart, end = config.closedEnd;
    for (let attempts=0; remaining && attempts<2000; attempts++) {
      date.setUTCDate(date.getUTCDate()+1);
      const key=dayKey(date), md=key.slice(5), year=date.getUTCFullYear(), week=date.getUTCDay();
      const closure=annual(start)&&annual(end)&&(start<=end ? md>=start&&md<=end : md>=start||md<=end);
      if (week===0 || week===6 || closure || extra.has(key)) continue;
      if (['01-01','01-06','04-25','05-01','06-02','08-15','11-01','12-08','12-25','12-26'].includes(md)) continue;
      if (year>=2026 && md==='10-04') continue;
      const monday=easter(year);monday.setUTCDate(monday.getUTCDate()+1);
      if (dayKey(monday)===key) continue;
      remaining--;
    }
    return remaining ? null : date;
  }
  class EmmetreProduct extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started=true;
      this.config=JSON.parse(this.dataset.config);
      this.t=this.config.text;
      this.abort=new AbortController();
      this.version=0;this.ready=false;this.busy=false;this.sending=false;
      this.$=selector=>this.querySelector(selector);
      this.$$=selector=>[...this.querySelectorAll(selector)];
      this.listen=(node,type,handler)=>node?.addEventListener(type,handler,{signal:this.abort.signal});
      this.form=this.$('form');
      this.$$('[data-view]').forEach(b=>this.listen(b,'click',()=>this.show(b.dataset.view)));
      if (!this.form) return;
      this.input=this.$('[data-file]');
      const names=this.config.optionNames || [];
      const normalize=name=>String(name || '').trim().toLowerCase();
      this.fi=names.findIndex(name=>normalize(name)===normalize(this.config.formatOption));
      this.qi=names.findIndex(name=>normalize(name)===normalize(this.config.quantityOption));
      this.variants=this.config.variants || [];
      this.quantities=[...new Set((this.config.quantities||'').split(',').map(x=>Number(x.trim())).filter(n=>Number.isInteger(n)&&n>=500&&n<=5000))];
      this.validCatalog=this.qi>=0 && (names.length===1 || (names.length===2 && this.fi>=0 && this.fi!==this.qi));
      const initial=this.variants.find(v=>v.id===this.config.selected && this.validVariant(v)) || this.variants.find(v=>this.validVariant(v));
      this.format=this.fi>=0 ? (initial?.options[this.fi] || this.$('[data-format]')?.dataset.format || '') : '';
      this.quantity=Number(initial?.options[this.qi]) || this.quantities[0];
      this.tax=this.config.taxIncluded ? 'in' : 'ex';
      this.$('[data-format-card]').hidden=this.fi<0;
      this.$$('[data-format]').forEach(b=>this.listen(b,'click',()=>{
        if (this.sending || b.dataset.format===this.format) return;
        this.format=b.dataset.format;
        const hadFile=this.ready||this.busy;
        this.clear();
        if(hadFile)this.$('[data-art-status]').textContent=this.t.file_changed;
        this.applyFormat();this.update();
      }));
      this.$$('[data-qty]').forEach(b=>this.listen(b,'click',()=>{if(!this.sending){this.quantity=Number(b.dataset.qty);this.update();}}));
      this.$$('[data-tax]').forEach(b=>this.listen(b,'click',()=>{this.tax=b.dataset.tax;this.update();}));
      this.listen(this.input,'change',()=>this.upload(this.input.files[0]));
      const drop=this.$('[data-drop]');
      ['dragenter','dragover'].forEach(type=>this.listen(drop,type,e=>{e.preventDefault();drop.classList.add('ep-dragging');}));
      this.listen(drop,'dragleave',()=>drop.classList.remove('ep-dragging'));
      this.listen(drop,'drop',e=>{
        e.preventDefault();drop.classList.remove('ep-dragging');
        if(this.sending)return;
        if(e.dataTransfer.files.length!==1){this.$('[data-art-status]').textContent=this.t.invalid_file;return;}
        const transfer=new DataTransfer();transfer.items.add(e.dataTransfer.files[0]);
        this.input.files=transfer.files;this.upload(this.input.files[0]);
      });
      this.listen(this.$('[data-clear]'),'click',()=>{if(!this.sending){this.clear();this.input.focus();}});
      this.listen(this.$('[data-preview]'),'click',()=>{
        this.show('art');this.$('.ep-stage').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
      });
      this.form.addEventListener('submit',event=>{
        event.preventDefault();event.stopImmediatePropagation();
        if(this.sending)return;
        this.update();
        if(!this.current || !this.validVariant(this.current) || this.busy || (this.config.requireArt && !this.ready)) {
          this.$('[data-error]').textContent=this.busy||!this.ready ? this.t.file_required : this.t.unavailable;
          return;
        }
        if(this.ready && this.input.files[0]!==this.acceptedFile){this.clear();this.$('[data-error]').textContent=this.t.file_required;return;}
        this.sending=true;
        this.$('[data-buy]').disabled=true;
        this.$('[data-buy]').textContent=this.t.sending;
        this.$$('[data-format], [data-qty], [data-clear]').forEach(b=>b.disabled=true);
        HTMLFormElement.prototype.submit.call(this.form);
      },{capture:true,signal:this.abort.signal});
      this.listen(window,'pageshow',()=>{this.sending=false;this.$('[data-clear]').disabled=false;this.$$('[data-format]').forEach(b=>b.disabled=false);this.$('[data-buy]').textContent=this.t.buy;this.update();});
      this.listen(document,'visibilitychange',()=>{if(!document.hidden)this.updateShipping();});
      this.interval=setInterval(()=>this.updateShipping(),30000);
      this.applyFormat();this.update();this.updateShipping();
    }
    disconnectedCallback() {
      this.abort?.abort();clearInterval(this.interval);this.reader?.abort();this.version++;
      if(this.objectURL)URL.revokeObjectURL(this.objectURL);
      this.objectURL=null;this.started=false;
    }
    validVariant(v) {
      const rule=v?.rule;
      return !!(this.validCatalog && v?.available && this.quantities.includes(Number(v.options[this.qi])) &&
        (!rule || ((rule.min || 1)<=1 && (!rule.max || rule.max>=1) && (rule.increment || 1)===1)));
    }
    resolve(quantity) {
      return this.variants.find(v=>Number(v.options[this.qi])===quantity && (this.fi<0 || v.options[this.fi]===this.format));
    }
    money(cents) {
      return new Intl.NumberFormat(this.config.locale||'it-IT',{style:'currency',currency:this.config.currency||'EUR'}).format(cents/100);
    }
    displayPrice(variant) {
      if(!this.config.taxToggle || !variant.taxable)return variant.price;
      const multiplier=1+Number(this.config.taxRate)/100;
      if(this.config.taxIncluded && this.tax==='ex')return variant.price/multiplier;
      if(!this.config.taxIncluded && this.tax==='in')return variant.price*multiplier;
      return variant.price;
    }
    paintPrice(element, value) {
      if (element.textContent === value) return;
      const previous = element.textContent;
      element._epPriceAnimation?.cancel();
      element.textContent = value;
      if (!this.pricesPainted || !previous || !value || previous === '—' || value === '—') return;
      if (!element.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      element._epPriceAnimation = element.animate([
        {opacity: 0.35, transform: 'translateY(5px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 220, easing: 'ease-out'});
    }
    update() {
      this.current=this.validCatalog?this.resolve(this.quantity):null;
      const available=this.validVariant(this.current);
      this.$$('[data-format]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.format===this.format)));
      this.$$('[data-qty]').forEach(b=>{
        const quantity=Number(b.dataset.qty),v=this.validCatalog?this.resolve(quantity):null;
        b.disabled=this.sending||!this.validVariant(v);
        b.setAttribute('aria-pressed',String(quantity===this.quantity));
        this.paintPrice(b.querySelector('[data-unit]'),v ? `${this.money(this.displayPrice(v)/quantity)} / ${this.t.pieces}` : '—');
      });
      this.$$('[data-tax]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.tax===this.tax)));
      this.$$('[data-total]').forEach(el=>this.paintPrice(el,this.current?this.money(this.displayPrice(this.current)):'—'));
      this.$$('[data-calculation]').forEach(el=>this.paintPrice(el,this.current?`${this.money(this.displayPrice(this.current)/this.quantity)} × ${this.quantity.toLocaleString(this.config.locale)} ${this.t.pieces}`:''));
      this.pricesPainted=true;
      this.$('[data-variant-id]').disabled=!available;
      this.$('[data-variant-id]').value=available?String(this.current.id):'';
      this.$('[data-pieces]').value=String(this.quantity||'');
      this.$('[data-format-property]').value=this.format;
      this.$('[data-error]').textContent=!this.validCatalog ? this.t.catalog_error : !available?this.t.unavailable:'';
      this.$('[data-buy]').disabled=this.sending||!available||this.busy||(this.config.requireArt&&!this.ready);
    }
    show(view) {
      if(view==='art'&&!this.ready)return;
      this.$$('[data-slide]').forEach(slide=>slide.hidden=slide.dataset.slide!==view);
      this.$$('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===view)));
      this.$('[data-tag]').textContent=this.t[view==='art'?'art_label':view==='flat'?'flat_label':'photo_label'];
    }
    applyFormat() {
      const cfg=this.$$('[data-format-config]').find(el=>el.dataset.formatConfig===this.format)?.dataset;
      ['photo','flat'].forEach(kind=>{
        const slide=this.$(`[data-slide="${kind}"]`),thumb=this.$(`[data-view="${kind}"]`);
        const src=cfg?.[kind]||slide.dataset.defaultImage;
        if(!slide._original)slide._original=slide.innerHTML;
        if(src){
          const image=new Image();image.src=src;image.alt=this.t[kind==='photo'?'photo_label':'flat_label'];image.width=1600;image.height=1200;
          slide.replaceChildren(image);thumb.replaceChildren(image.cloneNode());
        }else{slide.innerHTML=slide._original;thumb.textContent='□';}
      });
      [['[data-download]',cfg?.file],['[data-guide]',cfg?.guide]].forEach(([selector,url])=>{
        const link=this.$(selector),href=url||link.dataset.default;
        link.hidden=!href;if(href)link.href=href;else link.removeAttribute('href');
      });
      const noDownload=this.$('[data-download]').hidden;
      const note=this.$('[data-download-note]');if(note)note.hidden=noDownload;
      this.$('[data-dieline-card]').hidden=noDownload&&this.$('[data-guide]').hidden&&!this.$('[data-dieline-card] .ep-actions a:not([data-guide])');
      let visible=0;
      this.$$('[data-spec-format]').forEach(row=>{row.hidden=!!row.dataset.specFormat&&row.dataset.specFormat!==this.format;if(!row.hidden)visible++;});
      if(this.$('[data-spec-card]'))this.$('[data-spec-card]').hidden=!visible;
    }
    updateShipping() {
      const el=this.$('[data-shipping]');if(!el)return;
      const date=shipping(this.config);
      el.closest('.ep-shipping').hidden=!date;
      if(date){el.dateTime=dayKey(date);el.textContent=new Intl.DateTimeFormat(this.config.locale||'it-IT',{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(date);}
    }
    clear(resetInput=true) {
      this.version++;if(this.reader?.readyState===1)this.reader.abort();
      this.reader=null;this.ready=false;this.busy=false;this.acceptedFile=null;
      if(this.objectURL)URL.revokeObjectURL(this.objectURL);this.objectURL=null;
      if(resetInput)this.input.value='';
      this.$('[data-original]').removeAttribute('href');
      this.$('[data-view="art"]').hidden=true;
      this.$('[data-uploaded]').hidden=true;this.$('[data-progress]').hidden=true;this.$('[data-drop]').hidden=false;
      this.$('[data-art-image]').removeAttribute('src');this.$('[data-crop]').removeAttribute('src');
      this.$('[data-art-status]').textContent='';this.show('photo');this.update();
    }
    progress(value) {
      this.$('.ep-fill').style.width=`${value}%`;this.$('[data-percent]').textContent=`${value}%`;
      this.$('[role="progressbar"]').setAttribute('aria-valuenow',String(value));
    }
    async rasterize(buffer) {
      const moduleURL=new URL(this.config.pdfModule,location.href).href;
      const library=await import(moduleURL);
      library.GlobalWorkerOptions.workerSrc=new URL(this.config.pdfWorker,location.href).href;
      const base=new URL('.',new URL(this.config.resourceAsset,location.href)).href;
      const task=library.getDocument({data:new Uint8Array(buffer.slice(0)),cMapUrl:base,cMapPacked:true,standardFontDataUrl:base,wasmUrl:base,isEvalSupported:false});
      try {
        const doc=await task.promise,page=await doc.getPage(1),bounds=page.getViewport({scale:1});
        const scale=Math.min(2200/Math.max(bounds.width,bounds.height),Math.sqrt(5000000/(bounds.width*bounds.height)));
        const viewport=page.getViewport({scale}),canvas=document.createElement('canvas');
        canvas.width=Math.ceil(viewport.width);canvas.height=Math.ceil(viewport.height);
        await page.render({canvasContext:canvas.getContext('2d'),viewport,background:'rgb(255,255,255)'}).promise;
        return canvas.toDataURL('image/png');
      }finally{await task.destroy();}
    }
    read(file,version) {
      return new Promise((resolve,reject)=>{
        const reader=new FileReader();this.reader=reader;
        reader.onprogress=e=>{if(version===this.version&&e.lengthComputable)this.progress(Math.round(e.loaded/e.total*80));};
        reader.onload=()=>resolve(reader.result);reader.onerror=()=>reject(Error(this.t.invalid_file));reader.onabort=()=>reject(Error(this.t.invalid_file));
        reader.readAsArrayBuffer(file);
      });
    }
    async upload(file) {
      if(!file||this.sending)return;
      this.clear(false);const version=this.version;
      this.busy=true;this.update();this.$('[data-progress]').hidden=false;this.progress(0);
      try {
        if(file.size>Number(this.config.maxMB)*1024*1024)throw Error(`${this.t.file_large} ${this.config.maxMB} MB`);
        const extension=file.name.split('.').pop().toLowerCase();
        if(!['pdf','ai'].includes(extension)||file.size===0)throw Error(this.t.invalid_file);
        const buffer=await this.read(file,version);
        if(version!==this.version)return;
        const header=new TextDecoder().decode(buffer.slice(0,32)),pdf=header.startsWith('%PDF-');
        if(!pdf && !(extension==='ai'&&header.startsWith('%!PS-Adobe')))throw Error(this.t.invalid_file);
        this.progress(85);
        let preview=null;
        if(pdf){try{preview=await this.rasterize(buffer);}catch{throw Error(this.t.render_error);}}
        if(version!==this.version)return;
        this.objectURL=URL.createObjectURL(new Blob([file],{type:pdf?'application/pdf':'application/postscript'}));
        const open=this.$('[data-original]');open.href=this.objectURL;
        if(pdf)open.removeAttribute('download');else open.download=file.name;
        this.$('[data-art-name]').textContent=file.name;
        this.$('[data-uploaded-name]').textContent=file.name;
        const art=this.$('[data-art-image]'),crop=this.$('[data-crop]'),thumb=this.$('[data-view="art"]');
        art.hidden=crop.hidden=!preview;this.$('[data-no-preview]').hidden=!!preview;
        if(preview){art.src=crop.src=preview;thumb.replaceChildren(art.cloneNode());}else thumb.textContent='AI';
        this.acceptedFile=file;this.ready=true;this.busy=false;this.progress(100);
        this.$('[data-drop]').hidden=true;this.$('[data-uploaded]').hidden=false;thumb.hidden=false;
        this.show('art');this.update();
        setTimeout(()=>{if(version===this.version)this.$('[data-progress]').hidden=true;},400);
      }catch(error){
        if(version!==this.version)return;
        this.busy=false;this.ready=false;this.acceptedFile=null;this.input.value='';
        this.$('[data-progress]').hidden=true;this.$('[data-art-status]').textContent=error.message;this.update();
      }
    }
  }
  customElements.define('emmetre-product',EmmetreProduct);
})();